"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var prop_types_1 = __importDefault(require("prop-types"));

function SzTypographie(_a) {
  var type = _a.type,
      className = _a.className,
      children = _a.children;
  var containerClasses = classnames_1.default({
    'text-gray-light letter-spacing': type === 'text',
    'font-family-bold text-uppercase text-secondary': type === 'secondary-uppercase',
    'font-family-bold small': type === 'link',
    'font-family-bold small text-uppercase': type === 'nav',
    'font-family-bold small sz-text-underline': type === 'link-underline',
    'small text-gray-light': type === 'description',
    smaller: type === 'legend'
  }, className);

  if (type === 'text' || 'secondary-uppercase') {
    return react_1.default.createElement("p", {
      className: containerClasses
    }, children);
  }

  if (type === 'label') {
    return react_1.default.createElement("label", {
      className: containerClasses
    }, children);
  }

  return react_1.default.createElement("span", {
    className: containerClasses
  }, children);
}

exports.default = SzTypographie;
SzTypographie.defaultProps = {
  type: 'text'
};
SzTypographie.propTypes = {
  type: prop_types_1.default.oneOf(['text', 'secondary-uppercase', 'label', 'link', 'nav', 'link-underline', 'description', 'legend']),
  children: prop_types_1.default.string
};